"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAerisSource = exports.identifierForLayer = exports.createSource = exports.createTextSource = exports.createGeoJsonSource = exports.createVectorSource = exports.createTileSource = exports.mapRequestForConfig = exports.apiRequestForConfig = void 0;

var _ApiRequest = _interopRequireDefault(require("../../network/api/ApiRequest"));

var _MapRequest = _interopRequireDefault(require("../../network/maps/MapRequest"));

var _sources = require("./sources");

var _utils = require("../../utils");

var _Layers = require("../Layers");

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _this = void 0;

var apiRequestForConfig = function (account, config) {
  if (!(0, _utils.isset)(config)) return null;
  var request = config.service;

  if ((0, _utils.isset)(config.request)) {
    var opts = config.request;

    if (request) {
      var action = opts.action;
      var params = opts.parameters;

      if (action) {
        request.action(action);
      }

      if (params) {
        request.setParams(params);
      }
    } else if (opts.endpoint) {
      request = new _ApiRequest.default({
        server: opts.server,
        client: {
          id: account.id,
          secret: account.secret
        }
      });
      request.endpoint(opts.endpoint);

      if (opts.action) {
        request.action(opts.action);
      }

      if (opts.parameters) {
        request.setParams(opts.parameters);
      }
    }
  }

  return request;
};

exports.apiRequestForConfig = apiRequestForConfig;

var mapRequestForConfig = function (account, config) {
  var layer = config.layer,
      opts = config.request;
  var request = new _MapRequest.default({
    server: opts.server,
    client: {
      id: account.id,
      secret: account.secret
    }
  }, {
    type: "tile"
    /* TILE */

  });
  request.layers(layer);
  return request;
};

exports.mapRequestForConfig = mapRequestForConfig;

var createTileSource = function (identifier, config, factory) {
  var service = (0, _utils.get)(config, 'data.service');

  if ((0, _utils.isFunction)(service)) {
    service = service();
  }

  if (service instanceof _MapRequest.default) {
    service.type("tile"
    /* TILE */
    );
  } // console.log('TILE', identifier, config, service);


  return factory.tileLayer(identifier, service, config);
};

exports.createTileSource = createTileSource;

var createVectorSource = function (identifier, config) {
  return new _sources.VectorSource(identifier, config);
};

exports.createVectorSource = createVectorSource;

var createGeoJsonSource = function (identifier, config) {
  return new _sources.GeoJsonSource(identifier, config);
};

exports.createGeoJsonSource = createGeoJsonSource;

var createTextSource = function (identifier, config) {
  var props = (0, _utils.get)(config, 'data.properties'); // make sure required data property mappings are provided for text layers

  if (!props) {
    throw new Error('Value for `data.properties` option is required for text layers');
  } else {
    var timestamp = props.timestamp,
        value = props.value;

    if (!timestamp || !value) {
      throw new Error('Value for `data.properties.timestamp` and `data.properties.value` options are required for text layers');
    }
  }

  return new _sources.TextSource(identifier, config);
};

exports.createTextSource = createTextSource;

var createSource = function (identifier, type, config, factory) {
  var _a = config || {},
      account = _a.account,
      servers = _a.servers;

  delete config.account;
  delete config.servers;

  if (['tile', 'vector', 'geojson', 'text'].indexOf(type) === -1) {
    return null;
  }

  if (type === 'tile') {
    return createTileSource(identifier, config, factory);
  } // setup service for the module's data source


  if (config.data && !(0, _utils.isset)((0, _utils.get)(config, 'data.service'))) {
    var request = apiRequestForConfig(account, (0, _utils.extend)({}, {
      request: {
        server: servers.api
      }
    }, config.data));
    (0, _utils.set)(config, 'data.service', request);
  } // console.log('VECTOR', identifier, config);


  if (type === 'vector') {
    return new _sources.VectorSource(identifier, config);
  }

  if (type === 'geojson') {
    return new _sources.GeoJsonSource(identifier, config);
  }

  if (type === 'text') {
    return new _sources.TextSource(identifier, config);
  }

  return null;
};

exports.createSource = createSource;

var identifierForLayer = function (layer) {
  return layer.replace(/\:[^,]+/g, '');
};

exports.identifierForLayer = identifierForLayer;

var createAerisSource = function (layer, config, factory, layersMetadata) {
  if (config === void 0) {
    config = {};
  }

  var _a = config || {},
      account = _a.account,
      servers = _a.servers,
      _b = _a.timeline,
      timeline = _b === void 0 ? {} : _b;

  var key = identifierForLayer(layer);
  var identifier = (0, _utils.get)(config, 'id') || key;

  if ((0, _Layers.isTile)(layer) || config.type === 'tile') {
    delete config.data;
    var validate = (0, _utils.isset)(config.validate) ? config.validate : true;

    if (validate === true && !layersMetadata.exists(layer)) {
      console.warn("[Aeris] Cannot add layer {" + layer + "}, not a valid AerisWeather Maps layer. See https://www.aerisweather.com/support/docs/aeris-maps/reference/map-layers/ for the list of supported AMP layers.");
      return _this;
    }

    var isFutureLayer = layersMetadata.isFuture(layer);
    var isBase = layersMetadata.isBase(layer);
    var isOverlay = layersMetadata.isOverlay(layer);
    var alwaysShow = (0, _utils.get)(config, 'alwaysShow');

    if (!(0, _utils.isset)(alwaysShow)) {
      alwaysShow = isFutureLayer ? timeline.alwaysShowFuture : timeline.alwaysShowPast;
    }

    var service = mapRequestForConfig(account, {
      layer: layer,
      request: {
        server: servers.maps
      }
    });
    service.param('format', (0, _utils.get)(config, 'style.format') || 'png'); // override custom config values depending on layer type

    var sourceConfig_1 = config;

    if (isOverlay || isBase) {
      sourceConfig_1 = (0, _utils.extend)(sourceConfig_1, {
        pane: isOverlay ? 'admin' : null,
        offset: 0,
        alwaysShow: true,
        animation: {
          enabled: false
        }
      });
    } else {
      var totalIntervals = timeline.intervals;
      sourceConfig_1 = (0, _utils.extend)({
        animation: {
          enabled: true,
          intervals: totalIntervals
        }
      }, sourceConfig_1, {
        offset: (0, _utils.get)(config, 'data.offset'),
        future: isFutureLayer,
        alwaysShow: alwaysShow,
        animation: {
          bufferIntervals: timeline.bufferIntervals,
          showLoadingIntervals: timeline.showLoadingIntervals
        }
      });
    }

    sourceConfig_1.zIndex = (0, _utils.get)(config, 'style.zIndex');
    var source = createTileSource(identifier, (0, _utils.extend)(sourceConfig_1, {
      data: {
        service: service
      }
    }), factory);
    source.updateVisibility();
    return source;
  }

  var type = 'vector';

  if ((0, _Layers.isText)(layer)) {
    type = 'text';
  }

  var defaultConfig = (0, _style.configForLayer)(layer);
  var sourceConfig = (0, _utils.extend)({
    data: {
      request: {
        parameters: {
          plimit: 1
        }
      },
      coordinate: function (item) {
        return (0, _utils.get)(item, 'loc');
      }
    },
    requiresBounds: (0, _utils.get)(defaultConfig, 'data.request.action') !== "search"
    /* SEARCH */

  }, defaultConfig, config);
  return createSource(identifier, type, sourceConfig, factory);
};

exports.createAerisSource = createAerisSource;